import * as types from '../constants/ActionTypes';
import firebaseApp from '../firebase'
import api from '../../config/api.js';

const database = firebaseApp.database();

export function listenToConnected(){

  return dispatch => {
		database.ref(`.info/connected`)
		.on('value', snapshot=>{
			let val = snapshot.val();
				dispatch({
					type: types.SET_CONNECTED,
					payload: val
				})
		}, err=>{
			console.log('err',err);
		})
	}
}


export function setUserAsOwner(practice){
	return dispatch => {

		return api.post('/users/make_owner', practice)
		.then(d => {
			const { user, practice } = d.data
			dispatch(setUser(user))
			console.log("Practice: ", practice)
			return dispatch({
				type: types.SET_APP_PRACTICE,
				payload: practice
			})
		})
		.catch( e => {
			console.log("Error setting user as owner", e);
			throw new Error(e)
		})
	}
}

export function insertToast(toast){
	return {
		type: types.INSERT_TOAST,
		payload: toast
	}
}

export function removeToast(index){
	return {
		type: types.REMOVE_TOAST_BY_INDEX,
		payload: index
	}
}

export function setModal(name='', title=null, data={}, isOpen=false, state='' ){
	return {
		type: types.SET_MODAL,
		payload: {
			name: name,
			data: data,
			isOpen: isOpen,
			title: title,
			state: state
		}
	}
}

export function setTitle(title) {
	return {
		type: types.SET_TITLE,
		payload: title
	}
}

export function saveNotificationToken(token){
	return (dispatch) => {
		if (api.defaults.headers.common['x-access-token']) {
			api.post('/users/token', {
				't': token,
				'type': 'notification'
			})
			.then(d => d.data)
			.catch(err => err)
		}
	}
}

export function getPatientsForParent(parentId) {
	return (dispatch) => {
		api.get('/patients/parent/' + parentId)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error getting patients for parent', e)
			})
	}
}

// New Practice Types
export function fetchPracticeTypes() {
	console.log("fetchPracticeTypes")
	return (dispatch) => {
		if (api.defaults.headers.common['x-access-token']) {
			return api.get('/admin/practice_types')
				.then((d) => {
					dispatch({
						type: types.SET_PRACTICE_TYPES,
						payload: d.data
					})
					return Promise.resolve(d.data)
				})
				.catch((e) => {
					console.log(e);
					throw new Error(e)
				});

		} else {
			console.log("Unable to fetch practice type")
			return
		}
	}
}

export function fetchTherapyAreas() {
	// eslint-disable-next-line
	return (dispatch) => {
		if (api.defaults.headers.common['x-access-token']) {
			return api.get('/api/therapy_areas/')
				.then((d) => {
					if (d && d.data) {
						dispatch({
							type: types.SET_THERAPY_AREAS,
							payload: d.data
						})
						return Promise.resolve(d.data)
					}
				})
				.catch((e) => {
					console.log(e);
					throw new Error(e)
				});

		} else {
			return Promise.reject()
		}
	}
}

export function fetchTherapyCategories() {
	console.log("Fetching Therapy Categories")
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get('/api/therapy_categories/')
			.then((d) => {
				if (d && d.data) {
					dispatch({
						type: types.SET_THERAPY_CATEGORIES,
						payload: d.data
					})
					Promise.resolve(d.data)
				}
			})
			.catch((e) => {
				console.log(e);
				throw new Error(e)
			});
	}
}

export function fetchPractice(practiceName) {
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get(`/api/practices/${practiceName}`)
			.then((d) => { 
				 return dispatch({
					type: types.SET_APP_PRACTICE,
					payload: d.data
				}).payload
			})
			.catch((e) => {
				console.log('Error getting practice', e);
				return Promise.reject(e);
			});
	}
}

export function fetchPracticeById(practiceId) {
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get(`/practices/${practiceId}`)
			.then((d) => {
				if (d && d.data) {
					return dispatch({
						type: types.SET_APP_PRACTICE,
						payload: d.data
					}).payload
				}
			})
			.catch((e) => {
				console.log('Error getting practice', e);
				return Promise.reject(e);
			});
	}
}

export function checkIfSessionAssessment(id) {
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get(`/practices/${id}/checksessionsassessments`)
			.then(bool => {
				return bool
			})
			.catch(err => {
				console.log(err)
				return Promise.reject(e);
			})
	}
}

export function fetchPractices() {
	// eslint-disable-next-line
	return (dispatch) => {
		if (api.defaults.headers.common['x-access-token']) {
			return api.get('/api/practices/')
				.then((d) => {
					console.log("Received Practices")
					dispatch({
						type: types.SET_PRACTICES,
						payload: d.data
					})
				})
				.catch((e) => {
					console.log('Error getting practices', e);
				});
		} else {
			return false
		}
	}
}


export function searchPractices(search = '') {
	if(search === ''){
		return []
	}
	return api.get(`/api/practices/search/${search}`)
		.then((d) => {
			 return Promise.resolve(d.data || [])
		})
		.catch((e) => {
			console.log('Error getting practice', e);
			return Promise.reject(e);
		});

}

export function setAppField(f, v){
	return {
		type: types.SET_APP_FIELD,
		payload: {'field': f, 'value': v}
	}
}

export function joinPractice(practiceId) {
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get(`/practices/${practiceId}/join`)
			.then((d) => {
				dispatch({
					type: types.ADD_PRACTICE_TO_USER,
					payload: practiceId
				})

				return d
			})
			.catch((e) => {
				console.log('Error getting practice', e);
				return e;
			});
	}
}


export function fetchVideos() {
	// eslint-disable-next-line
	return (dispatch, getState) => {
		const { app } = getState();
		if (api.defaults.headers.common['x-access-token']) {
			return api.get('/api/videos/')
				.then((d) => {
					dispatch({
						type: types.SET_VIDEOS,
						payload: d.data
					})
					return d.data
				})
				.catch(e => {
					if (e.response.status === 401) {
						//get token and retry
						if (!app.gettingToken) {
							dispatch(getUserToken());
						}
						setTimeout(() => {
							dispatch(fetchVideos())
						}, 1000)
					}
					return e
				});
		} else {
			return Promise.reject()
		}
	}
}

// when a user signs in with a new accout - store the existing credentials to use for linking the accounts
export function setUserAccountsExistsCreds(credential, p) {
	return {
		type: types.SET_USER_ACCOUNT_EXISTS_CREDS,
		payload: {
			'credential': credential,
			p: p
		}
	}
}

export function gettingToken(val) {
	return {
		type: types.GETTING_TOKEN,
		payload: val
	}
}

export function setAuthenticating(val) {
	return (dispatch) => {
		dispatch({
			type: 'SET_AUTHENTICATING',
			payload: val
		})
	}
}

export function getUserToken() {
	return (dispatch, getState) => {
		const { app } = getState();

		if (!app.gettingToken && firebaseApp.auth().currentUser) {
			dispatch(gettingToken(true));
			return firebaseApp.auth().currentUser.getToken( /* forceRefresh */ true)
				.then((idToken) => {
					dispatch(setUser({ token: idToken, loggedIn: true }));
					return setTimeout(() => {
						dispatch(gettingToken(false));
						setAuthenticating(true)
						dispatch({
							type: 'SET_AUTHED',
							payload: true
						})

						return dispatch(saveUser({ token: idToken }));
					}, 500)
				});
		}
		return Promise.resolve()
	}
}

export function saveUser(user) {
	// eslint-disable-next-line
	if (api.defaults.headers.common['x-access-token']) {
		return (dispatch, getState) => {
			const { app, User } = getState();
			// Send token to the backend
			return api.get(`/users/auth?url=${User.User.signedInUrl || ''}`)
				.then((d) => {
					if (d.data.uid) {
						dispatch(setUser({loggedIn:true}));
						dispatch(setUser(d.data));
						dispatch({
							type: 'SET_AUTHED',
							payload: true
						})
						// do we need to save the notification token?
						if(app.mustSendNotificationToken){

							dispatch(saveNotificationToken(User.User.notificationToken))
						}
						return d.data;
					}
					throw new Error(d.data);
				}).catch(err => {
					if(!err.response){
						console.log('auth error ', err)
						return Promise.reject(err)
					}
					if (err.response.status === 401) {
						//get token and retry
						if (!app.gettingToken) {
							dispatch(gettingToken(true));
							return dispatch(getUserToken());
						} else {
							//return Promise.resolve()
							return Promise.reject(err)
						}
					}

				});
		}
	}
}

export function fetchUser(userUid) {
	// eslint-disable-next-line
	if (api.defaults.headers.common['x-access-token']) {
		return (dispatch) => {
			return api.get(`/users/${userUid}`)
				.then((d) => {
					if(d.data){
						dispatch({
							type: types.INSERT_USER,
							payload: d.data
						})
						return Promise.resolve(d.data)
					}else{
						throw new Error('No data')
					}
				})
				.catch((e) => {
					console.log('Error getting practice', e);
					return Promise.reject(e)
				});
		}
	}
}

export function setUser(user) {
	return {
		type: types.SET_USER,
		user
	};
}

export function removeUser() {
	return {
		type: types.REMOVE_USER
	};
}



// WEBPACK FOOTER //
// ./src/actions/index.js